import {
    FETCH_ATTRIBUTE_VALUES,
    FETCH_ATTRIBUTES,
    FETCH_FACETS,
    FETCH_SOURCES,
    SET_AM_ENTITIES,
    SET_AM_SELECTED_ATTRIBUTE_VALUE,
    SET_AM_SELECTED_STATE,
    SET_CUSTOM_ATTRIBUTES
} from '../actions/actionTypes';

const initialState = {
    attributes:             [],
    attributeValues:        [],
    customAttributes:       {},
    entities:               [],
    facets:                 [],
    selectedAttributeValue: null,
    selectedState:          [],
    sources:                []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ATTRIBUTE_VALUES:
            return {
                ...state,
                attributeValues: [...action.payload]
            };
        case FETCH_ATTRIBUTES:
            return {
                ...state,
                attributes: [...action.payload]
            };
        case FETCH_FACETS:
            return {
                ...state,
                facets: [...action.payload]
            };
        case FETCH_SOURCES:
            return {
                ...state,
                sources: [...action.payload]
            };
        case SET_AM_ENTITIES:
            return {
                ...state,
                entities: [...action.payload]
            };
        case SET_AM_SELECTED_ATTRIBUTE_VALUE:
            return {
                ...state,
                selectedAttributeValue: action.payload
            };
        case SET_AM_SELECTED_STATE:
            return {
                ...state,
                selectedState: [...action.payload]
            };
        case SET_CUSTOM_ATTRIBUTES:
            return {
                ...state,
                customAttributes: { ...action.payload }
            };
        default:
            return state;
    }
};
